import styles from "./ErrorState.module.css";

/**
 * Componente ErrorState
 * Muestra el estado de error con opción de reintentar
 *
 * @param {Object} props
 * @param {string} props.title - Título del error
 * @param {string} props.message - Mensaje descriptivo del error
 * @param {string} props.errorCode - Código de error técnico (opcional)
 * @param {string} props.errorDetails - Detalles técnicos del error (opcional)
 * @param {function} props.onRetry - Función para reintentar
 * @param {function} props.onClose - Función para cerrar
 * @param {boolean} props.darkMode - Modo oscuro
 */
const ErrorState = ({
  title = "No pudimos completar tu solicitud",
  message = "Lo sentimos, hubo un problema al procesar tu solicitud. Por favor, verifica tu conexión o inténtalo de nuevo en unos momentos.",
  errorCode,
  errorDetails,
  onRetry,
  onClose,
  darkMode = false,
}) => {
  return (
    <div
      className={`${styles["error-container"]} ${darkMode ? styles.dark : ""}`}
    >
      {/* Icono de error con animación shake */}
      <div className={styles["error-icon-container"]}>
        <div className={styles["error-glow"]}></div>
        <div className={styles["error-icon-wrapper"]}>
          <span className={styles["error-icon"]}>⚠️</span>
          <div className={styles["error-badge"]}>
            <span className={styles["error-badge-icon"]}>!</span>
          </div>
        </div>
      </div>

      {/* Texto */}
      <h2 className={styles["error-title"]}>{title}</h2>
      <p className={styles["error-message"]}>{message}</p>

      {/* Detalles técnicos (colapsable) */}
      {(errorCode || errorDetails) && (
        <div className={styles["error-details"]}>
          <details>
            <summary className={styles["error-details-summary"]}>
              <span>Ver detalles técnicos</span>
              <span className={styles["error-details-icon"]}>▼</span>
            </summary>
            <div className={styles["error-details-content"]}>
              {errorCode && (
                <>
                  Error Code: {errorCode}
                  <br />
                </>
              )}
              {errorDetails || "Service Unavailable: Request Timeout"}
            </div>
          </details>
        </div>
      )}

      {/* Acciones */}
      <div className={styles["error-actions"]}>
        {onRetry && (
          <button
            className={styles["error-button-primary"]}
            onClick={onRetry}
            type="button"
          >
            <span className={styles["error-button-icon"]}>↻</span>
            <span>Reintentar</span>
          </button>
        )}

        {onClose && (
          <button
            className={styles["error-button-secondary"]}
            onClick={onClose}
            type="button"
          >
            Cerrar
          </button>
        )}
      </div>

      {/* Enlace de soporte */}
      <div className={styles["error-support"]}>
        <p className={styles["error-support-text"]}>
          ¿El problema persiste?{" "}
          <button
            type="button"
            className={styles["error-support-link"]}
            onClick={() => {
              // Aquí agregas la lógica para contactar soporte
            }}
          >
            Contactar Soporte
          </button>
        </p>
      </div>
    </div>
  );
};

export default ErrorState;
